import script from "./application.vue?vue&type=script&setup=true&lang=js"
export * from "./application.vue?vue&type=script&setup=true&lang=js"

import "./application.vue?vue&type=style&index=0&id=5a7b6d76&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7b6d76"]])

export default __exports__